// extracted by mini-css-extract-plugin
export default {"wysiwyg":"WYSIWYG_wysiwyg__Nvhi3","wysiwyg--size__small":"WYSIWYG_wysiwyg--size__small__e3BTd","spin":"WYSIWYG_spin__T81ZE"};